import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withOktaAuth } from '@okta/okta-react';

import { TranslatedCopy } from '../intl/TranslatedCopy';

import { Button, Spinner } from '../components/';

import { closeModal, openModal, enableModal, disableModal } from '../components/modal/actions';
import { getGamedayAccount, getIsMANASalesOrg, getIsEUSalesOrg } from '../gamedayAccount/selectors';
import { getUserInvoiceAuth } from '../auth/actions';
import { getUserData } from '../user/selectors';
import { userTypes } from '../types/user';
import { SEC_ACCOUNTS } from '../feature/constants';
import { getFeature } from '../feature/actions';
import {
  GA_EVENT_PAGE_VIEW,
  GA_EVENT_INVOICE_CONTINUE_CLICK,
  GA_EVENT_INVOICE_PAGE_VIEW,
  sendEventToGA
} from '../analytics/constants';

const availableForCountryCodes = ['CN'];

export class Invoices extends Component {
  constructor(props) {
    super(props);

    this.handleConfirmClick = this.handleConfirmClick.bind(this);
    this.handleInvoicesClick = this.handleInvoicesClick.bind(this);
  }

  componentDidMount() {
    const { getFeature } = this.props;
    getFeature(SEC_ACCOUNTS);
  }

  async handleConfirmClick() {
    const {
      closeModal,
      disableModal,
      enableModal,
      user,
      gamedayAccount,
      isMANASalesOrg,
      isEUSalesOrg,
      getUserInvoiceAuth,
      oktaAuth
    } = this.props;
    const { id, email: username, role, language, locale } = user;
    const accountNumber = gamedayAccount.billable?.accountNumber || gamedayAccount.accountNumber;
    const {
      accessToken: { accessToken }
    } = await oktaAuth.tokenManager.getTokens();

    const isSECInvoice = isMANASalesOrg || isEUSalesOrg;
    const authRequestPayload = {
      language,
      locale,
      role,
      soldTo: accountNumber,
      token: accessToken,
      userId: id,
      username,
      isSECInvoice
    };
    // Begin by disabling the modal
    disableModal();

    getUserInvoiceAuth(authRequestPayload)
      .then(() => {
        closeModal();
        const invoiceUrl = isSECInvoice
          ? import.meta.env.VITE_OFS_INVOICE_APP_URL
          : import.meta.env.VITE_INVOICE_APP_URL;
        window.open(invoiceUrl, '_blank');
      })
      .catch(e => {
        // eslint-disable-next-line no-console
        console.log(e);
      })
      .then(() => {
        // Enable the modal when the request has completed
        enableModal();
      });

    sendEventToGA(GA_EVENT_INVOICE_CONTINUE_CLICK);
  }

  handleInvoicesClick() {
    const { closeModal, openModal } = this.props;

    openModal({
      type: 'alert',
      title: <TranslatedCopy id='invoices.modal.title' />,
      content: <TranslatedCopy id='invoices.modal.copy' />,
      confirmText: <TranslatedCopy id='invoices.modal.confirm' />,
      confirmAction: () => this.handleConfirmClick(),
      cancelText: <TranslatedCopy id='global.cancel' />,
      cancelAction: closeModal,
      disabledContent: <Spinner />
    });

    sendEventToGA(GA_EVENT_PAGE_VIEW, { pageViewType: GA_EVENT_INVOICE_PAGE_VIEW });
  }

  render() {
    const { isMobile, user } = this.props;
    const userCountry = user.country.toUpperCase();
    const buttonClasses = isMobile
      ? // eslint-disable-next-line max-len
        'bg-secondary-grey border-bottom body-4 u-bold prl5-sm pt4-sm pb4-sm u-full-width ta-sm-l text-color-primary-dark'
      : 'p0-sm mb1-sm body-3 u-bold text-color-secondary';

    const isVisible = !availableForCountryCodes.includes(userCountry);

    return isVisible ? (
      <li>
        <Button data-e2e='invoices' className={buttonClasses} textLink onClick={this.handleInvoicesClick}>
          <TranslatedCopy id='invoices.link' />
        </Button>
      </li>
    ) : null;
  }
}

Invoices.defaultProps = {
  isMobile: false
};

Invoices.propTypes = {
  disableModal: PropTypes.func.isRequired,
  enableModal: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
  oktaAuth: PropTypes.object.isRequired,
  openModal: PropTypes.func.isRequired,
  getUserInvoiceAuth: PropTypes.func.isRequired,
  gamedayAccount: PropTypes.object.isRequired,
  isMANASalesOrg: PropTypes.bool.isRequired,
  isEUSalesOrg: PropTypes.bool.isRequired,
  user: userTypes.isRequired,
  getFeature: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  gamedayAccount: getGamedayAccount(state),
  isMANASalesOrg: getIsMANASalesOrg(state),
  isEUSalesOrg: getIsEUSalesOrg(state),
  user: getUserData(state)
});

export default connect(mapStateToProps, {
  openModal,
  closeModal,
  enableModal,
  disableModal,
  getUserInvoiceAuth,
  getFeature
})(withOktaAuth(Invoices));
